export const WEIGHT_CLASSES = [
  'Peso Pesado (até 120,2 kg)',
  'Meio-Pesado (até 93,0 kg)',
  'Peso Médio (até 83,9 kg)',
  'Meio-Médio (até 77,1 kg)',
  'Peso Leve (até 70,3 kg)',
  'Peso Pena (até 65,8 kg)',
  'Peso Galo (até 61,2 kg)',
  'Peso Mosca (até 56,7 kg)',
  'Peso Galo Feminino (até 61,2 kg)',
  'Peso Mosca Feminino (até 56,7 kg)',
  'Peso Palha Feminino (até 52,2 kg)',
];

